import { z } from "zod";

export const idSchema = z.uuid();
export const isoDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Data inválida").refine((value) => !Number.isNaN(Date.parse(`${value}T12:00:00Z`)), "Data inválida");
export const timeSchema = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, "Horário inválido");
export const moneySchema = z.number().min(0).max(9_999_999.99).refine((value) => Math.round(value * 100) === Number((value * 100).toFixed(6)), "Use no máximo duas casas decimais");
export const trimmed = (max: number) => z.string().trim().min(1).max(max);

export const onlyDigits = (value: string | null | undefined) => (value ?? "").replace(/\D/g, "");

/** CPF com 11 dígitos; aceita com ou sem pontuação e devolve só os dígitos. */
export const cpfSchema = z.string().transform(onlyDigits).refine((digits) => digits.length === 11, "CPF deve ter 11 dígitos");

export function formatCpf(value: string | null | undefined): string {
  const digits = onlyDigits(value);
  return digits.length === 11 ? `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}` : (value ?? "");
}

export const dateRangeQuerySchema = z.object({ from: isoDateSchema, to: isoDateSchema }).refine((range) => range.from <= range.to, "Período inválido");
export type DateRange = z.infer<typeof dateRangeQuerySchema>;

/** Formato único de erro devolvido pela API. */
export interface ApiErrorBody {
  error: { code: string; message: string; details?: unknown; requestId?: string };
}
